module.exports = __webpack_public_path__ + "img/missing-tangram.7d48ccaa.png";